/* unplugin-vue-components disabled */import script from "./IndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=17020ec6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17020ec6"]])

export default __exports__